import { useTranslation } from 'react-i18next'

import { useUserData } from '../../../../hooks'
import { isStaffUser } from '../../../../utils/user'
import { ListItem } from '../../../ListItem'
import {
  ProfileBuildingGroupsWidgetItem,
  ProfileBuildingsWidgetItem,
  useWidgetContext,
  WidgetContentItemsList,
} from '../../../Widget'
import {
  getAudienceBuildingGroupItemProps,
  getAudienceBuildingItemProps,
  getAudienceRecipientItemProps,
  getAudienceUserStatusItemProps,
  getPostAudienceRecipientItems,
  getPostHasBuildingsOrGroups,
} from '../NewsboardPostProfileWidgetAudience.utils'
import { NewsboardPostProfileWidgetAudienceForm } from '../NewsboardPostProfileWidgetAudienceForm'

function NewsboardPostProfileWidgetAudienceContent({ postData, onSubmit }) {
  const { t } = useTranslation()

  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  const user = useUserData()
  const isStaff = isStaffUser(user)

  const buildings = postData?.building_objs
  const buildingGroups = postData?.building_group_objs

  const hasBuildingGroups = buildingGroups?.length > 0

  const userStatuses = postData?.user_info_status_objs

  const recipients = getPostAudienceRecipientItems({
    audience: postData?.new_audience,
    hasBuildingsOrGroups: getPostHasBuildingsOrGroups(postData),
    isStaff,
    t,
  })

  return isEditMode ? (
    <NewsboardPostProfileWidgetAudienceForm
      postData={postData}
      onCancel={handleDisableEditMode}
      onSubmit={onSubmit}
      onSuccess={handleDisableEditMode}
    />
  ) : (
    <>
      {recipients.length > 0 ? (
        <WidgetContentItemsList
          Item={ListItem}
          getItemPropsFromValue={getAudienceRecipientItemProps}
          items={recipients}
          title={t('NewsboardPostProfile.AudienceTypeKey', {
            type: postData?.type,
          })}
        />
      ) : null}
      {userStatuses?.length > 0 ? (
        <WidgetContentItemsList
          Item={ListItem}
          getItemPropsFromValue={getAudienceUserStatusItemProps}
          items={userStatuses}
          title={t('Newsboard.RecipientsUserInfoStatusLabelKey')}
        />
      ) : null}
      {buildings?.length > 0 && !hasBuildingGroups ? (
        <WidgetContentItemsList
          Item={ProfileBuildingsWidgetItem}
          getItemPropsFromValue={getAudienceBuildingItemProps}
          items={buildings}
          title={t('NewsboardPostProfile.AudienceBuildingsWidgetListTitleKey', {
            count: buildings.length,
          })}
        />
      ) : null}
      {buildingGroups?.length > 0 ? (
        <WidgetContentItemsList
          Item={ProfileBuildingGroupsWidgetItem}
          getItemPropsFromValue={getAudienceBuildingGroupItemProps}
          items={buildingGroups}
          title={t('Widget.BuildingGroupsListTitleKey', {
            count: buildingGroups.length,
          })}
        />
      ) : null}
    </>
  )
}

export default NewsboardPostProfileWidgetAudienceContent
